export enum ExamResultType {
    Normal = 1,
    Abnormal = 2,
    UnableToExamine = 3
}
